module.exports = __webpack_public_path__ + "static/media/DT-UK-2023nav.6ff3e9ba.png";